export interface IJWTInfo {
    oid: string;
    email: string;
    given_name: string;
    family_name: string;
    exp: number;
    appClaims: {
        role: string;
    };
}

export const jwtParser = (
    token: string,
    // currentView = inject(WINDOW),
): IJWTInfo => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        //eslint-disable-next-line
        window
            .atob(base64)
            .split('')
            .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('') || '',
    );
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return JSON.parse(jsonPayload) as IJWTInfo;
};
